export default class PopupBlocked extends Error {
  constructor() {
    super("The popup is blocked by the browser");
  }
}
